import BigNumber from 'bignumber.js';

import { CompanyOwner } from '@funnels/types';

export function getCompanyOwnershipPercentage(companyOwners: CompanyOwner[], applicantId: string) {
  const applicantOwnership = companyOwners.find((ownership) => ownership.applicantId === applicantId);
  return applicantOwnership?.percentOwned
    ? new BigNumber(applicantOwnership.percentOwned).multipliedBy(100).toNumber()
    : '';
}
